import { render, staticRenderFns } from "./HelpContacts.vue?vue&type=template&id=44a486de&"
import script from "./HelpContacts.vue?vue&type=script&lang=js&"
export * from "./HelpContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports